<template>
    <mounting-portal mount-to="#portalvue-unga76-articles">
        <div 
            v-if="articles.length > 0"
            class="grid grid-cols-4 grid-rows-2 gap-6 md:gap-8"
            dir="rtl">

            <a  
                v-for="article, articleIndex in articles"
                :key="articleIndex"
                :href="article.link"
                class="bg-pale-grey relative"
                :class="setGridClasses(articleIndex)">

                <featured-media-component
                    :media="article.featured_media"
                    :link="article.link"
                    :short-headline="article.short_headline"
                    size="large"
                    class="flex-shrink-0"
                    :resize="true"
                    :class="setMediaClasses(articleIndex)" />

                <div class="absolute bottom-0 right-0 mb-5 mr-5 md:mb-8 md:mr-8 max-w-md">
                    <span 
                        class="font-waheed leading-10 text-2xl highlight-title max-w-md"
                        :class="setTitleClasses(articleIndex)">
                        {{ article.short_headline }}
                    </span>
                </div>
            </a>
        </div>

        <div v-if="hasMoreToLoad" 
            class="flex justify-center mt-30px">
            <img
                class="cursor-pointer"
                v-on:click="loadArticles()"
                :src="CDN_GET('assets/mhr/icons/icon-listing-more.svg')"
                alt="icon load more" />
        </div>
    </mounting-portal>
</template>

<script>
import axios from 'axios'
import FeaturedMediaComponent from '../Layout/FeaturedMedia/FeaturedMediaComponent.vue'

export default {
    props: ['ignore', 'section'],
    data() {
        return {
            articles: [],
            cursor: null,
            isLoading: false,
        }
    },
    components: {
        FeaturedMediaComponent
    },
    computed: {
        hasMoreToLoad() {
            return false === this.isLoading && 
                null !== this.cursor
        }
    },
    methods: {
        setTitleClasses(index) {
            let classes = ''

            if (
                index === 0 ||
                index === 4 ||
                index === 5 
            ) {
                classes += ' md:text-4xl md:leading-loose'
            } else {
                classes += ' md:leading-extra-loose'
            }

            return classes
        },
        setMediaClasses(index) {
            let classes = 'w-full h-290px'

            if (
                index === 0 || 
                index === 4 || 
                index === 5
            ) {
                classes += ' md:h-588px'
            }

            if (
                index === 1 ||
                index === 2 ||
                index === 3
            ) {
                classes += ' md:h-278px'
            }
            
            return classes
        },
        setGridClasses(index) {
            let classes = 'col-span-4 row-span-2';

            if (
                index === 2 ||
                index === 3
            ) {
                classes += ' md:col-span-1'
            } else {
                classes += ' md:col-span-2'
            }

            if (
                index === 1 || 
                index === 2 || 
                index === 3 
            ) {
                classes += ' md:row-span-1'
            } else {
                classes += ' md:row-span-2'
            }

            return classes
        },
        loadArticles() {
            this.isLoading = true

            let uri = 'home/latest-popular-weekly' +
                '?type=latest' +
                '&base=unga76' +
                '&limit=6' +
                '&cursor=' + this.cursor +
                '&ignore=' + this.ignore +
                '&section=' + this.section 

            axios.get(uri)
                .then(resp => {
                    const response = resp.data

                    if (response.data.length > 0) {
                        this.articles.push(...response.data)
                        this.cursor = response.cursor
                    }
                    
                    this.isLoading = false
                })
                .catch(e => {
                    console.error('LatestPopularWeeklyComponent.vue')
                    console.error(e)
                })
                .then(resp => {
                    this.isLoading = false
                });
        }
    },
    mounted() {
        this.loadArticles()
    }
}
</script>